import {
  getWorkspaceId,
  ProductsRequest,
  useAppSelector,
  useGetCustomerReportMutation,
  useGetProductsByCustomerMutation,
} from '@zonofi/zono-money-store';
import {
  createCatalogListEnqueuer,
  createCustomerProfileEnqueuer,
} from '../../helper';
import { RequestPriority } from '../../queue/request/request-queue';
import { useMemo } from 'react';

export function useCustomerProfileFetcher() {
  const sellerWorkspaceId = useAppSelector(getWorkspaceId);
  const [getProfileMutation] = useGetCustomerReportMutation();
  const [getCatalogListMutation] = useGetProductsByCustomerMutation();

  const enqueueCustomerProfile = useMemo(
    () => createCustomerProfileEnqueuer(getProfileMutation),
    []
  );

  const enqueueCatalogList = useMemo(
    () => createCatalogListEnqueuer(getCatalogListMutation),
    []
  );

  // For user clicking a customer card → should always get result ASAP
  const fetchProfileHighPriority = (customerId: string) =>
    enqueueCustomerProfile(
      {
        params: { sellerWorkspaceId },
        body: {
          customerIds: [customerId],
          sellerworkspaceid: sellerWorkspaceId,
        },
      },
      RequestPriority.HIGH,
      customerId
    );

  // For background sync → non-blocking
  const fetchProfileLowPriority = (customerId: string) =>
    enqueueCustomerProfile(
      {
        params: { sellerWorkspaceId },
        body: {
          customerIds: [customerId],
          sellerworkspaceid: sellerWorkspaceId,
        },
      },
      RequestPriority.LOW,
      customerId
    );

  const fetchCatalogListLowPriority = (payload: ProductsRequest) =>
    enqueueCatalogList(payload, RequestPriority.LOW);

  const fetchCatalogListHighPriority = (payload: ProductsRequest) =>
    enqueueCatalogList(payload, RequestPriority.HIGH);

  return {
    fetchProfileHighPriority,
    fetchProfileLowPriority,
    fetchCatalogListHighPriority,
    fetchCatalogListLowPriority,
  };
}
